import React, { useRef, useEffect } from "react";
import { Link } from "react-router-dom";
import sal from "sal.js";
import { Helmet } from "@dr.pogodin/react-helmet";

export default function BackupSolutions() {
  useEffect(() => {
    document.title = "#1 Trusted Backup Solution For Your Business";
        sal();
      }, []);
  return (
    <>
      <Helmet>
        <title>#1 Trusted Backup Solution For Your Business</title>
        <meta name="description" content="Backing up data can be crucial for websites in case of cyberattacks.
        Infinitive Host offers automatic or scheduled backups as per your business needs and purchased hosting plans." />
        <meta name="keywords" content="backup solutions,enterprise backup solutions,data backup solutions,backup solutions for business" />
        <meta property="og:url" content={`${import.meta.env.VITE_FRONTEND_URL}/backup-solutions`} />
        <link rel="canonical" href={`${import.meta.env.VITE_FRONTEND_WWW_URL}/backup-solutions`} />
        <meta property="og:title" content="#1 Trusted Backup Solution For Your Business" />
        <meta property="og:description" content="Backing up data can be crucial for websites in case of cyberattacks. Infinitive Host offers automatic or scheduled backups as per your business needs and purchased hosting plans." />
      </Helmet>
      <section className="banner-bg bg-dark ssl-banner">
        <div className="container">
            <div className="row align-items-center g-4">
              <div className="col-lg-6">
                  <div className="pb-40">
                    <span className="fs-18 fw-bold text-primary mb-2 sal-animate" data-sal="slide-up" data-sal-duration="1000" data-sal-delay="300" data-sal-easing="ease-in-out-sine">Backup That Back You Up</span>
                    <h1 className="text-white mb-3 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">Expert Data Backup Solution For Data Security</h1>
                    <p className="text-white mb-8 max-text-60 text-opacity-75 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">One stop solution for backing up your data with 100% expert support. Choose from our daily, weekly, and monthly data backups that exactly fits your business needs.</p>
                    <Link to="#" className="btn btn-primary btn-arrow btn-lg fs-14 fw-medium rounded sal-animate open-live-chat btn-height" data-sal="slide-up" data-sal-duration="1000" data-sal-delay="300" data-sal-easing="ease-in-out-sine" data-discover="true">
                      <span className="btn-arrow__text">Talk to an Expert
                        <span className="btn-arrow__icon">
                          <i className="fa-solid fa-arrow-right"></i>
                        </span>
                      </span>
                    </Link>
                  </div>
              </div>
              <div className="col-lg-6 col-xxl-6 ipad-mt">
                  <div className="cloud-hero__img sal-animate" data-sal="fade" data-sal-duration="1000" data-sal-delay="300" data-sal-easing="ease-in-out-sine"><img alt="image" className="img-fluid full-width-img" src="/images/backup-sol-banner.webp" /></div>
              </div>
            </div>
        </div>
      </section>
      <div className="simple-box-section pb-100 linux-hosting-points-section">
        <div className="pb-60">
            <div className="container">
              <div className="row g-4 align-items-center justify-content-xl-between">
                  <div className="col-lg-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                    <small className="d-inline-block mb-2 fw-bold bg-success-subtle text-success-emphasis border border-success-subtle px-3 py-1 rounded"><span className="d-inline-block w-2 h-2 bg-success rounded-circle me-1"></span>Your Data is Backed Up.</small>
                    <h2 className="mb-4">Our Top-Of-The-Line Data Backup Solutions</h2>
                    <p className="max-text-56 mb-0 fw-semibold">Don’t let the worry of data loss be a big distraction to your mental peace. With our reliable and trusted backup solution, you can have peace of mind knowing your critical data is backed up and secure.</p>
                  </div>
                  <div className="col-lg-6 col-xl-5 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="400" data-sal-easing="ease-in-out-sine">
                    <div className="card">
                        <div className="card-body cloud-hosting-vid-card">
                                <div className="features-video position-relative z-1">
                                    <img src="/images/infi-common-video-yt-thumb.jpg" alt="image" className="img-fluid w-100"/>
                                    <Link to="https://youtu.be/x10KM9gI110?si=kVgGnbSAsh-zfKn7" target="_blank" className="btn gradient-bg w-15 h-15 d-grid place-content-center rounded-circle position-absolute top-50 start-50 translate-middle fs-24 text-white popup-init">
                                        <i className="fa-solid fa-play"></i>
                                    </Link>
                                </div>
                            </div>
                    </div>
                  </div>
              </div>
            </div>
        </div>
        <div className="container">
            <div className="row g-4">
              <div className="col-md-6 col-lg-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                  <div className="card border-0 shadow-sm rounded-4 h-100">
                    <div className="card-body p-md-6 p-xl-8">
                        <div className="mb-8"><img alt="image" className="img-fluid" src="/images/optimum-data-security.webp" /></div>
                        <h6 className="mb-4">Optimum Data Security</h6>
                        <p className="mb-0">Sit back and relax with our backup solution plans as we ensure regular monitoring and creating copies of your files and data daily, weekly, and monthly bases.</p>
                    </div>
                  </div>
              </div>
              <div className="col-md-6 col-lg-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="400" data-sal-easing="ease-in-out-sine">
                  <div className="card border-0 shadow-sm rounded-4 h-100">
                    <div className="card-body p-md-6 p-xl-8">
                        <div className="mb-8"><img alt="image" className="img-fluid" src="/images/scheduled-backups.webp" /></div>
                        <h6 className="mb-4">Scheduled Backups</h6>
                        <p className="mb-0">We know every business is different and its backup demands too. That’s why with Infinitive Host you can choose automatic or scheduled back-ups for your business.</p>
                    </div>
                  </div>
              </div>
              <div className="col-md-6 col-lg-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="500" data-sal-easing="ease-in-out-sine">
                  <div className="card border-0 shadow-sm rounded-4 h-100">
                    <div className="card-body p-md-6 p-xl-8">
                        <div className="mb-8"><img alt="image" className="img-fluid" src="/images/data-In-sync-mode.webp" /></div>
                        <h6 className="mb-4">Data In Sync Mode</h6>
                        <p className="mb-0">Synchronising helps to share or access things easily. We ensure that your data will always be in sync mode so you always get real time backups and optimum security.</p>
                    </div>
                  </div>
              </div>
              <div className="col-md-6 col-lg-6 sal-animate" data-sal="slide-up" data-sal-duration="1000" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                  <div className="card border-0 shadow-sm rounded-4 h-100">
                    <div className="card-body p-md-6 p-xl-8">
                        <div className="mb-8"><img alt="image" className="img-fluid" src="/images/premium-security-features.webp" /></div>
                        <h6 className="mb-4">Premium Security Features</h6>
                        <p className="mb-0">Infinitive Host provides premium security features with all its backup solution plans. We ensure to keep your data 100% private and secure from hackers & other threats.</p>
                    </div>
                  </div>
              </div>
            </div>
        </div>
      </div>

      <div className="pb-60">
        <div className="pb-60">
            <div className="container">
                <div className="row g-4 align-items-center">
                    <div className="col-lg-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                        <img src="images/easy-reliable-trusted-backups.webp" alt="image" className="img-fluid" />
                    </div>
                    <div className="col-lg-6">
                        <div className="ps-lg-8 pe-xxl-12">
                            <span className="d-block mb-2 text-primary fs-18 fw-semibold sal-animate" data-sal="slide-up" data-sal-duration="1500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                                Relax!! Your Data is Safe.
                            </span>
                            <h3 className="mb-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                                Easy, Reliable & Trusted Backups
                            </h3>
                            <ul>
                                <li>
                                    <b>Process :</b> Now there are no more manual backups, all the process has been conducted automatically.
                                </li>
                                <li>
                                    <b>Scheduled Backups :</b> With us, you get the benefit of scheduled backups (daily, weekly, and monthly).
                                </li>
                                <li>
                                    <b>Secure :</b> Our all backup plans are backed by powerful security features that provide maximum security.
                                </li>
                                <li><b>Easy :</b> Installing our backup solution is as easy as blinking your eyes. Just talk to our expert and he will take charge.</li>
                                <li>
                                    <b>Support :</b> We offer end to end server support facility on our backup solutions. Our experts listen to your issues and provide solutions.
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div className="pb-60">
            <div className="container">
                <div className="row g-4 align-items-center">
                    <div className="col-lg-6">
                        <div className="ps-lg-8 pe-xxl-12">
                            <span className="d-block mb-2 text-primary fs-18 fw-semibold sal-animate" data-sal="slide-up" data-sal-duration="1500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                                Second Chance? Already Saved.
                            </span>
                            <h3 className="mb-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                                Backup Solutions On Cloud Storage
                            </h3>
                            <p data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine" className="sal-animate">
                                We know data security is your prime concern and thus ours too, that’s why Infinitive Host offers the industry leading best cloud storage services to fit at whatever level of business you’re operating at: small, medium or enterprise. 
                            </p>
                             <p data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine" className="sal-animate">
                             With cloud backup, your data is stored off-site in a secure data center, protecting it from physical damage or theft. Plus, with automated backups, your data is regularly and consistently backed up, ensuring that you always have access to the most recent version of your data.
                             </p>
                        </div>
                    </div>
                    <div className="col-lg-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                        <img src="images/backup-solutions-on-cloud-storage.webp" alt="image" className="img-fluid" />
                    </div>
                </div>
            </div>
        </div>
    </div>

      <section>
        <div className="container">
            <div className="row justify-content-center">
                <div className="col-xxl-7 col-xl-8">
                    <div className="d-flex align-items-center justify-content-center gap-2 mb-2 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                        <small className="d-inline-block mb-2 fw-bold bg-primary-subtle text-primary-emphasis border border-primary-subtle px-3 py-1 rounded">
                            <span className="d-inline-block w-2 h-2 bg-primary rounded-circle me-1"></span>Backup, Secured.
                        </small>
                    </div>
                    <div className="text-center mb-8">
                        <h2 className="text-dark mb-3 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">Impressive Features That Always Lets You Worry Free.</h2>
                    </div>
                </div>
            </div>
            <div className="row g-4">
                <div className="col-lg-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                    <div className="bg-white p-6 p-xl-10 rounded-3 h-100">
                        <div className="d-flex align-items-center justify-content-between gap-3 mb-4">
                            <h6 className="text-dark mb-0">Automatic Backups</h6>
                            <p className="h5 mb-0 text-dark text-opacity-25">01</p>
                        </div>
                        <div className="d-flex gap-6 flex-wrap flex-sm-nowrap">
                            <div className="flex-shrink-0">
                                <img src="/images/automatic-backups.webp" alt="icon" className="img-fluid"/>
                            </div>
                            <div>
                                <p className="mb-0">With our automatic backup solutions you can choose daily, weekly, & monthly backups as per the requirement. Our expert support ensures full protection to your data.</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-lg-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="400" data-sal-easing="ease-in-out-sine">
                    <div className="bg-white p-6 rounded-3 p-xl-10 h-100">
                        <div className="d-flex align-items-center justify-content-between gap-3 mb-4">
                            <h6 className="text-dark mb-0">Threat Protection</h6>
                            <p className="h5 mb-0 text-dark text-opacity-25">02</p>
                        </div>
                        <div className="d-flex gap-6 flex-wrap flex-sm-nowrap">
                            <div className="flex-shrink-0">
                                <img src="/images/threat-protection.webp" alt="icon" className="img-fluid"/>
                            </div>
                            <div>
                                <p className="mb-0">Our tech experts are available round-the-clock to monitor the malicious activity to your server with daily malware scans & making free copies to your data.</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-lg-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="400" data-sal-easing="ease-in-out-sine">
                    <div className="bg-white p-6 rounded-3 p-xl-10 h-100">
                        <div className="d-flex align-items-center justify-content-between gap-3 mb-4">
                            <h6 className="text-dark mb-0">Safeguard From Data Crash</h6>
                            <p className="h5 mb-0 text-dark text-opacity-25">03</p>
                        </div>
                        <div className="d-flex gap-6 flex-wrap flex-sm-nowrap">
                            <div className="flex-shrink-0">
                                <img src="/images/safeguard-from-data-crash.webp" alt="icon" className="img-fluid"/>
                            </div>
                            <div>
                                <p className="mb-0">To stop sudden data crash is not in our hands but the prevention from its loss is in. We make automated copies to your files on a monthly and weekly basis.</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-lg-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="400" data-sal-easing="ease-in-out-sine">
                    <div className="bg-white p-6 rounded-3 p-xl-10 h-100">
                        <div className="d-flex align-items-center justify-content-between gap-3 mb-4">
                            <h6 className="text-dark mb-0">One Click Restoration</h6>
                            <p className="h5 mb-0 text-dark text-opacity-25">04</p>
                        </div>
                        <div className="d-flex gap-6 flex-wrap flex-sm-nowrap">
                            <div className="flex-shrink-0">
                                <img src="/images/one-click-restoration.webp" alt="icon" className="img-fluid"/>
                            </div>
                            <div>
                                <p className="mb-0">It’s very painful to see a sudden website crash, but don’t worry we will save you from here too. You can restore your files and data with just a single click option.</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-lg-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="400" data-sal-easing="ease-in-out-sine">
                    <div className="bg-white p-6 rounded-3 p-xl-10 h-100">
                        <div className="d-flex align-items-center justify-content-between gap-3 mb-4">
                            <h6 className="text-dark mb-0">Backup Copies</h6>
                            <p className="h5 mb-0 text-dark text-opacity-25">05</p>
                        </div>
                        <div className="d-flex gap-6 flex-wrap flex-sm-nowrap">
                            <div className="flex-shrink-0">
                                <img src="/images/backup-copies.webp" alt="icon" className="img-fluid"/>
                            </div>
                            <div>
                                <p className="mb-0">With our backup solutions you can download the copies of your files and data on your local storage that helps you in easy migration and provide security of data in emergency situations.</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-lg-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="400" data-sal-easing="ease-in-out-sine">
                    <div className="bg-white p-6 rounded-3 p-xl-10 h-100">
                        <div className="d-flex align-items-center justify-content-between gap-3 mb-4">
                            <h6 className="text-dark mb-0">Flexibility</h6>
                            <p className="h5 mb-0 text-dark text-opacity-25">06</p>
                        </div>
                        <div className="d-flex gap-6 flex-wrap flex-sm-nowrap">
                            <div className="flex-shrink-0">
                                <img src="/images/flexibility.webp" alt="icon" className="img-fluid"/>
                            </div>
                            <div>
                                <p className="mb-0">Why experience flexibility only in operations? Get flexible backup plans too. You can choose the date and time of your server backup, you can also shift with our on-demand backups.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
      </section>
      <section className="simple-box-section pt-60 pb-100">
        <div className="container">
          <div className="row">
              <div className="col-12">
                  <div className="card rounded-3 cta-3 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                      <div className="card-body px-6 pt-60 pb-60">
                          <div className="row justify-content-center">
                              <div className="col-md-11 col-lg-8 col-xl-8">
                                  <div className="text-center">
                                    <span className="section-title style-bg fadeInUp mb-4 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="200" data-sal-easing="ease-in-out-sine">Are You Ready?</span>
                                      <h4 className="mb-4">
                                          Go online with us.
                                      </h4>
                                      <p className="mb-6">
                                        Install Our Trusted & Reliable Backup Solutions Now.
                                      </p>
                                      <Link to="tel:7737300013" className="btn btn-primary btn-arrow btn-arrow-xl btn-lg fs-14 fw-medium rounded me-sm-2 btn-height">
                                          <span className="d-inline-block me-1 flex-shrink-0">
                                              <i className="las la-comments"></i>
                                          </span>
                                          <span className="btn-arrow__text">
                                              +91-7737300013
                                              <span className="btn-arrow__icon">
                                                  <i className="fa-solid fa-arrow-right"></i>
                                              </span>
                                          </span>
                                      </Link>
                                      <Link to="#" className="btn btn-primary btn-arrow btn-arrow-xl btn-lg fs-14 fw-medium rounded ms-sm-2 mt-sm-0 mt-4 open-live-chat btn-height">
                                          <span className="d-inline-block me-1 flex-shrink-0">
                                              <i className="las la-comments"></i>
                                          </span>
                                          <span className="btn-arrow__text">
                                              Talk to an Expert
                                              <span className="btn-arrow__icon">
                                                  <i className="fa-solid fa-arrow-right"></i>
                                              </span>
                                          </span>
                                      </Link>
                                  </div>
                              </div>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
        </div>
      </section>
    </>
  );
}